import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import {MicroFormService} from "./micro-form.service";
import {MicroSelectComponent} from "./micro-select.component";
import {MicroTextareaComponent} from "./micro-textarea.component";
import {MicroInputComponent} from "./micro-input.component";
import {MicroDateComponent} from "./micro-date.component";
import {DatePickerModule} from "../datepicker/datepicker.module";
import {HttpClientModule} from "@angular/common/http";
import {GraphqlCoreModule} from "../graphql/graphql-core.module";

@NgModule({
  providers: [
    MicroFormService,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    DatePickerModule,
    HttpClientModule,
    GraphqlCoreModule,
  ],
  declarations: [
    MicroSelectComponent,
    MicroTextareaComponent,
    MicroInputComponent,
    MicroDateComponent,
  ],
  exports: [
    MicroSelectComponent,
    MicroTextareaComponent,
    MicroInputComponent,
    MicroDateComponent,
  ],
})

export class MicroFormModule {
}
